import { Avatar, Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import ReactMarkdown from "react-markdown";

import type { ChatMessage } from "./types";

type AgenticChatMessageProps = {
  message: ChatMessage;
};

export const AgenticChatMessage: React.FC<AgenticChatMessageProps> = ({
  message,
}) => {
  const isUser = message.role === "user";

  if (isUser) {
    return (
      <Flex justify="flex-end" align="flex-end" gap="2">
        <Box
          maxW="75%"
          px="4"
          py="3"
          borderRadius="xl"
          bg="gray.800"
          color="white"
        >
          <Text fontSize="sm" lineHeight="tall" whiteSpace="pre-wrap">
            {message.content}
          </Text>
        </Box>
        <Avatar size="xs" bg="orange.300" />
      </Flex>
    );
  }

  return (
    <Box
      alignSelf="flex-start"
      maxW="90%"
      fontSize="sm"
      color="gray.700"
      lineHeight="1.7"
      sx={{
        "& p": { margin: 0 },
        "& strong": { fontWeight: "semibold" },
        "& ul, & ol": { pl: 4, my: 1 },
      }}
    >
      <ReactMarkdown>
        {message.content.charAt(0).toUpperCase() + message.content.slice(1)}
      </ReactMarkdown>
    </Box>
  );
};
